module.exports = __webpack_public_path__ + "img/gen019.5988731f.svg";